const tokenKey = 'token'

class JwtService {
  private token: string | null = null

  public saveToken = (token: string) => {
    localStorage.setItem(tokenKey, token)
    this.token = token
    document.cookie = `hangfire_token=${token}; path=/; samesite=strict`
  }

  public getToken = () => {
    if (this.token != null) {
      return this.token
    }

    this.token = localStorage.getItem(tokenKey) as string | null
    return this.token
  }

  public clear = () => {
    this.token = null
    localStorage.removeItem(tokenKey)
    document.cookie = 'hangfire_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT'
  }
}
export default new JwtService()
